import { createSelector } from "@reduxjs/toolkit";
import { IAppState } from "../types";
import { TESTCASE_RUN_STATUS } from "../../types/global.enum";

import { buildRunKey } from "../resuders/run.reducer";

const runSelectors = (state: IAppState) => state.run;

// export const getTestCaseRunState = (projectId: number, testCaseId: number) =>
//   createSelector([runSelectors], (run) => 
    
//     console.log('Fetching run state for projectId:', projectId, 'testCaseId:', testCaseId, 'run:', run),
    
//     run?.[buildRunKey(projectId, testCaseId)]);

    export const getTestCaseRunState = (projectId: number, testCaseId: number) =>
      createSelector([runSelectors], (run) => {
        const runKey = buildRunKey(projectId, testCaseId);
        const runState = run?.[runKey];
    
        return runState;
      });

export const isTestCaseRunning = (projectId: number, testCaseId: number) =>
  createSelector([runSelectors], (run) => run?.[buildRunKey(projectId, testCaseId)]?.status === TESTCASE_RUN_STATUS.STARTED);

export const isTestCaseRunCleared = (projectId: number, testCaseId: number) =>
  createSelector(
    [runSelectors],
    (run) => run?.[buildRunKey(projectId, testCaseId)]?.runCleared === true
  );
